<template>
    <living-box-component
            :active="!$_.isEmpty(employee)"
            :full-screen="fullScreen"
            v-on:update:active="setEmployee({})"
            v-on:update:full-screen="fullScreenClick">
        <template v-slot:main>
            <pre-loader-component :visible="loading"></pre-loader-component>
            <scroll-hide-nav v-show="!loading">
                <header-navigation></header-navigation>
                <div class="max-w-content">
                    <component-switcher>
                        <people-list
                                :key="currentTab"
                                :show-quetionnaire="showQuestionnaire"
                                :list="getTabPeople"
                                :active-id="employee ? employee.id : 0"
                                :class="tabClass">
                        </people-list>
                    </component-switcher>
                </div>
            </scroll-hide-nav>
        </template>
        <template v-slot:leaving>
            <scroll-hide-nav v-show="!loading" :ops="ops" :nav-manupulation="false">
                <current-employee-component v-show="!$_.isEmpty(employee)" :employee="employee" :candidate="!currentTab" @close="setEmployee({})"></current-employee-component>
            </scroll-hide-nav>
        </template>
    </living-box-component>
</template>

<script>
    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
    import PreLoaderComponent from "../common/PreLoader";
    import LivingBoxComponent from "../common/LivingBoxComponent";
    import PeopleList from "./PeopleList";
    import CurrentEmployeeComponent from "./CurrentEmployee";
    import ScrollHideNav from "../common/ScrollHideNav";
    import HeaderNavigation from "../common/HeaderNavigation";
    import ComponentSwitcher from "../common/ComponentSwitcher";

    export default {
        name: 'people-component-box',
        components: {
            ComponentSwitcher,
            HeaderNavigation,
            ScrollHideNav,
            CurrentEmployeeComponent,
            PeopleList,
            LivingBoxComponent,
            PreLoaderComponent,
        },
        data() {
            return {
                currentScrollPosition: 0,
                ops: {
                    vuescroll: {
                        pullRefresh: {
                            enable: true
                        },
                        pushLoad: {
                            enable: true,
                            auto: true,
                            autoLoadDistance: 10
                        }
                    },
                },
                tabs: [
                    {
                        id: 0,
                        title: 'Кандидаты'
                    },
                    {
                        id: 1,
                        title: 'Стажёры'
                    },
                    {
                        id: 2,
                        title: 'Сотрудники'
                    },
                    {
                        id: 3,
                        title: 'Архив'
                    },
                ],
                loading: true,
            }
        },
        computed: {
            ...mapState({
                fullScreen: state => state.people.fullScreen,
                people: state => state.people.people,
                groups: state => state.people.groups,
                employee: state => state.people.currentEmployee,
                currentTab: state => state.headerNav.active
            }),
            ...mapGetters('people', [
                'getGroup'
            ]),
            showQuestionnaire() {
                return this.getGroup(this.currentTab) ? this.getGroup(this.currentTab).questionnaire : false
            },
            tabClass() {
                return this.getGroup(this.currentTab) ? this.getGroup(this.currentTab).class : ''
            },
            getTabPeople() {
                return this.people.filter(human =>
                    human.groupId === this.groups[this.currentTab].id
                );
            }
        },
        methods: {
            ...mapActions([
                'visibleNav',
            ]),
            ...mapActions('people',[
                'getPeople',
                'setEmployee',
                'getEmployee'
            ]),
            ...mapMutations('people',[
                'setFullScreen'
            ]),
            ...mapMutations([
                'setHeaderNavItems',
                'setHeaderNavActive'

            ]),
            closeList(e) {
                this.setActiveList(e)
            },
            hideClick() {
                this.setFullScreen(!this.fullScreen)
            },
            handleScroll(vertical) {
                let delta = parseInt(this.currentScrollPosition - vertical.scrollTop);
                this.currentScrollPosition = vertical.scrollTop;
                this.visibleNav(delta);
            },
            tabClick(index) {
                this.currentTab = index
            },
            fullScreenClick() {
                this.setFullScreen(!this.fullScreen)
            }
        },
        created() {
            this.setHeaderNavItems(this.tabs);
            this.setHeaderNavActive(this.tabs[0].id);
            this.$store.commit('setAppClass', 'humans-component');
            this.getPeople().then(() => {
                let postId = this.$route.params.id;
                if (postId) {
                    this.getEmployee(postId);
                }
                this.loading = false;
            });
        },
        beforeRouteLeave(to, from, next) {
            this.setHeaderNavItems([]);
            next()
        },

    }
</script>

<style scoped>
    .loading-box {
        margin-top: 200px;
    }

</style>
